import { Icons } from '../Icons/Icons';
import { string } from '../../localization';

import XRegExp from 'xregexp';

// Pending: Hardcode has to be replaced
export const APP_PUBLIC_PATH = 'javascripts/HPAC-React/public';

export const Constants = {
  URL_REGEX: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
  URL_START_REGEX: /^(htt|http)/
};

export const REGEX = {
  SCRIPT_FORMAT: XRegExp(
    "^[\\p{L}\\p{Thai}\\p{Arabic},。、，'+_\n@ .:#&%～?=/-\\d]+(?:\\s[\\p{L}\\p{Thai}\\p{Arabic}\\d;]+)?$"
  )
};

export const EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

export const DEFAULT_FONT = 'HP Simplified Light';

export const SLIDER_MIN_VALUE = 0;
export const SLIDER_MAX_VALUE = 100;
export const MINIMUM_ZOOM_VALUE = 1;
export const MAXIMUM_ZOOM_VALUE = 1.5;
export const NORMAL_WALL_COLOR = 'F4F4F4';
export const DARK_CONTRAST_COLOR = '5C5E5F';
export const BLACK_COLOR = '000000';
export const STICKER_WORKSPACE_COLOR = '7F7F7F';
export const PATTERN_COUNT = 30;

// Keyboard keyCode
export const ENTER_KEY_CODE = 13;
export const DELETE_KEY_CODE = 46;
export const BACKSPACE_KEY_CODE = 8;
export const LEFT_ARROW_KEY_CODE = 37;
export const RIGHT_ARROW_KEY_CODE = 39;
export const UP_ARROW_KEY_CODE = 38;
export const DOWN_ARROW_KEY_CODE = 40;

export const PATTERN_DESIGN = 'Pattern Design © Collection';
export const PATTERN_DESIGN_TITLE = 'Pattern Design';
export const UNSPLASH = 'Unsplash';
export const FOTOLIA = 'Fotolia © Collection';
export const VECTEEZY = 'Vecteezy';
export const DREAMSTIME = 'Dreamstime';
export const GETTY_IMAGE = 'Getty Images';
export const I_STOCK = 'iStock';
export const VECTEEZY_TYPE = 'vecteezy';
export const DREAMSTIME_TYPE = 'dreamstime';
export const ADOBE_STOCK = 'Adobe Stock © Collection';
export const HP_MOSAIC = 'HP Mosaic';
export const HOSTED_CONTENT = 'Hosted content';

// TOOL BAR ITEMS
export const LOCK_TOOL = 1;
export const SEND_TO_BACK_TOOL = 2;
export const BRING_TO_FRONT_TOOL = 3;
export const DUPLICATE_TOOL = 4;
export const FLIP_TOOL = 5;
export const SCALE_TO_FILL_TOOL = 6;
export const SCALE_TOOL = 7;
export const SCALE_ALL_TOOL = 8;
export const ROTATE_TOOL = 9;
export const DELETE_TOOL = 10;
export const RECOLOR_TOOL = 11;
export const RESIZE_ARBITRARILY_TOOL = 12;
export const RESIZE_PROPORTIONALLY_TOOL = 13;
export const ALIGN_TOOL = 14;
export const CLEAR_ALL_TOOL = 15;
export const GROUP_ALL_TOOL = 16;
export const UNGROUP_TOOL = 17;
export const TILE_TOOL = 18;
export const UNLOCK_TOOL = 19;
export const UNTILE_TOOL = 20;
export const TRANSPARENCY_TOOL = 21;
export const ZOOM_TOOL = 23;
export const ZOOM_IN_TOOL = 24;
export const ZOOM_OUT_TOOL = 25;
export const STRETCH_TOOL = 26;
export const UNSTRETCH_TOOL = 27;
export const SET_SIZE_TOOL = 28;

export const NORMAL_STATE = 'Normal';
export const SELECTED_STATE = 'Selected';
export const DISABLED_STATE = 'Disabled';

export const INSPIRATION_COUNT = 10;
export const DREAMSTIME_PAGE_COUNT = 100;

// Orientation

export const LANDSCAPE_KEY = 'Landscape';
export const PORTRAIT_KEY = 'Portrait';

// Unit system
export const METRIC_KEY = 'Metric'; // cm
export const IMPERIAL_KEY = 'Imperial'; // inch

// Currency symbol placement
export const BEFORE_PRICE_KEY = 'Before price';

// Final-check
export const METER_TO_CENTIMETERS_CONVERSION_KEY = 100;
export const SQ_CENTIMETER_TO_SQ_METER = 10000;
export const FEET_TO_INCHES_CONVERSION_KEY = 12;
export const SQ_INCHES_TO_SQ_FEET = 144;
export const INCHES_TO_CENTIMETERS_CONVERSION_KEY = 2.54;
export const PERCENTAGE_KEY = 100;
export const SQ_FT_TO_SQ_METER = 10.764;

// links
export const LINK_READER_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.hp.link';
export const LINK_READER_APPLE_STORE =
  'https://itunes.apple.com/us/app/linkreader/id716209670?mt=8';
export const LINK_HP_CLIK =
  'https://support.hp.com/us-en/drivers/selfservice/hp-click-printing-software/15550865';
export const LINK_HP_SMART_STREAM =
  'https://www8.hp.com/us/en/commercial-printers/pagewide-printers/smartstream-pagewide.html';
export const MY_WORK = '/lite_partner/redirect_to_my_designs';

export const TERMS_OF_USE_PRINTER =
  'https://designer.integration.hpwallart.com/terms_and_conditions';
export const TERMS_AND_CONDITION =
  'https://designer.integration.hpwallart.com/terms_and_conditions';
export const TERMS_AND_CONDITIONS_FRANCE =
  'https://store.hp.com/FranceStore/Html/terms_FR.pdf';

export const PRIVACY_STATEMENT =
  'https://www8.hp.com/us/en/privacy/ww-privacy.html';
export const PRIVACY_STATEMENT_FRANCE =
  'https://www8.hp.com/fr/fr/privacy/privacy.html';

export const PRIVACY_NOTICE =
  'http://welcome.hp.com/country/privacy/privacynotice/index.html';

export const TERMS_OF_SERVICE =
  'https://designer.integration.hpwallart.com/TermsOfService.html';
export const FORGOT_PASSWORD_PATTERN =
  'https://patterndesigns.com/api/passwordRecovery/passwordReset';

// Element Types
export const UNDEFINED_ELEMENT = 'Undefined';
export const THEME_KEY = 'Theme';
export const CHILD_THEME_KEY = 'ChildTheme';
export const SCENE_KEY = 'Scene';
export const SOLID_FILL_KEY = 'ColorFill';
export const BACKGROUND_KEY = 'Background';
export const ELEMENT_KEY = 'Element';
export const PHOTO_KEY = 'Photo';
export const TEXT_ELEMENT_TYPE = 'Text';
export const USER_PHOTO_TYPE = 'UserPhoto'; // Can appear at any of background/annotation Layer
export const BACKGROUND_TYPE = 'backgrounds'; // for Getty iStock api
export const PHOTOS_TYPE = 'photos'; // for Getty iStock api
export const OBJECTS_TYPE = 'objects'; // for Getty iStock api
export const PROJECT_KEY = 'project';

// Layers: Elements can be added to any of these layers
export const LAYER_ID_BACKGROUND = 'BackgroundLayer';
export const LAYER_ID_ANNOTATION = 'AnnotationLayer';

// User Photo Types. Since we use Layer id we might not need this OR
// might require only during transition from backend
export const USER_PHOTO_SCENE_TYPE = 'UserPhotoScene'; // Can appear only at background Layer
export const USER_PHOTO_ELEMENT_TYPE = 'UserPhotoElement'; // Can appear only at annotation Layer

// Image Sources supported
export const PATTERN_DESIGN_IMAGE_SOURCE = 'pattern_design';
export const VECTEEZY_IMAGE_SOURCE = 'vecteezy';
export const GETTY_IMAGE_SOURCE = 'getty_images';
export const I_STOCK_IMAGE_SOURCE = 'istock';
export const UNSPLASH_IMAGE_SOURCE = 'unsplash';
export const ADOBE_STOCK_IMAGE_SOURCE = 'adobe_stock';
export const HP_MOSAIC_IMAGE_SOURCE = 'hp_mosaic';
export const INSTAGRAM_IMAGE_SOURCE = 'instagram';
export const LOCAL_IMAGE_SOURCE = 'local';
export const AI_IMAGE_SOURCE = 'openai';
export const DROPBOX_IMAGE_SOURCE = 'dropbox';
export const HOSTED_CONTENT_IMAGE_SOURCE = 'hosted_content';

export const SOLID_COLOR_TYPE = 'Solid';

export const FROM_COMPUTER = 'From Computer';
export const FROM_DROPBOX = 'From Dropbox';
export const FROM_INSTAGRAM = 'From Instagram';
export const DREAMSTIME_IMAGE_SOURCE = 'dreamstime';

export const BACKGROUND_TAB_KEY = 'scenesData';
export const ELEMENT_TAB_KEY = 'elementsData';
export const PHOTO_TAB_KEY = 'photosData';
export const MATERIAL_TAB_KEY = 'material';
export const TEMPLATES_TAB_KEY = 'templates';
export const UPLOAD_TAB_KEY = 'upload';
export const SETTINGS_TAB_KEY = 'settings';
export const OPEN_AI = 'ai';
export const MY_ROOM_TAB_KEY = 'myRoom';

export const inspirationsTab = 'inspiration';
export const WALL_LAYOUT_KEY = 'WallLayout';
export const FURNITURE_TAB_KEY = 'furniture';
export const FIXTURE_TAB_KEY = 'fixture';
export const MULTI_WALL_TAB_KEY = 'wallHandlerTab';

export const REQUEST_TYPE_GET = 'get';
export const REQUEST_TYPE_POST = 'post';
export const REQUEST_TYPE_PUT = 'put';
export const REQUEST_TYPE_DELETE = 'delete';

export const Validity = [
  '1 week',
  '2 week',
  '1 month',
  '3 months',
  '6 months',
  '1 year',
  '2 years',
  '3 years',
  '4 years',
  '5 years'
];

export const Colors = {
  // Used for text color picker and color to search
  HARDCODED_COLORS: [
    '#00ffff',
    '#ee1289',
    '#00ff00',
    '#ffff00',
    '#ff8000',
    '#4eee94',
    '#79cdcd',
    '#ff0000',
    '#cd3333',
    '#b22222',
    '#33a1c9',
    '#43cd80',
    '#ffffff',
    '#912cee',
    '#808069'
  ]
};

// Align tool id
export const ALIGN_TOOL_KEY = {
  ALIGN_LEFT: 'align-left',
  ALIGN_CENTER: 'align-center',
  ALIGN_RIGHT: 'align-right',
  ALIGN_TOP: 'align-top',
  ALIGN_MIDDLE: 'align-middle',
  ALIGN_BOTTOM: 'align-bottom'
};

// Top bar icon alt name
export const TOPBAR_ALT_KEY = {
  HELP_ICON: 'help-icon',
  SHARE_ICON: 'share-icon',
  SAVE_ICON: 'save-icon',
  PROFILE_ICON: 'profile-icon',
  ENTER_ICON: 'enter-icon',
  MYWORK_ICON: 'my-work-icon'
};

// Next arrow
export const NEXT_STEP_ARROW = '>';

// Project Types
export const NEW_POSTER_CATEGORY = 'newposter';
export const GIFTWRAPS_CATEGORY = 'giftwrap';
export const WALLPAPER_CATEGORY = 'wallpaper';
export const POSTER_CATEGORY = 'poster';
export const CANVAS_CATEGORY = 'canvas';
export const CUTOUT_CATEGORY = 'cutout';
export const COMMERCIAL_POSTER_CATEGORY = 'commercialposter';
export const PERSONIZE_CATEGORY = 'personize';
export const FACEMASK_CATEGORY = 'facemask';
export const DOUBLE_SIDED_BANNER_KEY = 'doublesidedbanner';
export const HANGING_BANNER_KEY = 'hangingbanner';
export const STRETCHED_BANNER_KEY = 'banner';

export const BorderBufferSize = 2.0;
export const TrimBufferSize = 0.125;
export const RoundingErrorBufferSize = 0.125;

// page
export const PRODUCT_GROUP_PAGE = 0;
export const PRODUCT_LIST_PAGE = 1;
export const SIZE_SELECTION_PAGE = 2;
export const DESIGN_PAGE = 3;
export const FINAL_CHECK_PAGE = 4;
export const INITIAL_PRINT_PAGE = 5;
export const FILE_PROCESSING_PAGE = 6;
export const DESIGN_SHARE_PAGE = 7;
export const PRINT_PAGE = 8;
export const THANK_YOU_PAGE = 9;

export const CANVAS = 'canvas';
export const MULTI_CANVAS = 'multi-canvas';

export const DEFAULT_WALL_WIDTH = 137.8;
export const DEFAULT_WALL_HEIGHT = 94.49;

// Required field
export const ASTERISK = '*';

export const HYPHEN = '-';
export const MULTIPLY = 'x';
export const INCH_SYMBOL = "''";

export const PLATFORM_USER_NAME = 'platform';
export const PLATFORM_EMAIL_ADDRESS = 'platform@example.com';

// cookies
export const ACTIVITY_STORE_LOGIN = 'STORELOGIN';
export const PRINITING_OPTION_COOKIE_NAME = 'PRINTINGOPTION';
export const LANGUAGE_CODE = 'LANGUAGECODE';
export const ACTIVITY_COOKIE_NAME = '009C834A-2E16-449E-8983-9A4D45669A71';
export const DESIGNER_COOKIE_NAME = 'ce709472-7164-47fa-8251-f7b0ddeddb11';
export const ACTIVITY_SAVE = 'SAVE';
export const FEEDBACK_ACTIVITY = 'FEEDBACKACTIVITY';
export const LITE_SAVE_ACTIVITY = 'LITESAVE';
export const LITE_CHECKOUT_ACTIVITY = 'LITECHECKOUT';
export const WEBLINK_SAVE_ACTIVITY = 'WEBLINKSAVE';
export const WEBLINK_CHECKOUT_ACTIVITY = 'WEBLINKCHECKOUT';
export const DOCUMENT_COLORS_SAVE_ACTIVITY = 'DOCUMENTCOLORS';

export const INSPIRATION_STATE = 'inspiration';
export const EDITING_STATE = 'editing';
export const TEMPLATE_STATE = 'template';
export const SOFT_DELETED_STATE = 'soft_deleted';
export const EXPITED_STATE = 'expired';
export const PRO_DESIGN_STATE = 'pro_design';

// Color picker handling string
export const PATTERN_COLOR = 'Pattern Color';
export const SHADOW_COLOR = 'Shadow Color';
export const DOCUMENT_COLOR = 'Document Color';
export const TEXT_COLOR = 'Text Color';
export const SOLID_COLOR = 'Solid Color';
export const RECOLOR = 'Recolor';

// Rip
export const RIP_LIST = [
  {
    name: 'HP Click',
    img: Icons.hpCilck,
    message: null
  },
  {
    name: 'HP SmartStream',
    img: Icons.hpSmartStream,
    message: null
  },
  {
    name: 'ONYX',
    img: Icons.unix,
    message: string.RIPS_BLOCK1
  },
  {
    name: 'SAi',
    img: Icons.sai,
    message: string.RIPS_BLOCK2
  },
  {
    name: 'CALDERA',
    img: Icons.caldera,
    message: string.RIPS_BLOCK3
  },
  {
    name: 'ColorGATE',
    img: Icons.colorGate,
    message: string.RIPS_BLOCK4
  },
  {
    name: 'ergosoft',
    img: Icons.ergosoft,
    message: string.RIPS_BLOCK5
  },
  {
    name: 'PrintFactory',
    img: Icons.printFactory,
    message: string.RIPS_BLOCK6
  }
];

// display size
export const NAME = 'Name';
export const DIMENSION = 'Dimension';

export const PREMIUM_TYPE = 'PREMIUM';

// webLink save types
export const EXISTING_FOLDER_TYPE = 'existingFolderType';
export const NEW_FOLDER_TYPE = 'newFolderType';
export const NO_FOLDER_TYPE = 'noFolderType';

// string colors
export const ERROR_STRING_COLOR = 'red';
export const DEFAULT_STRING_COLOR = 'black';

export const CANVAS_FRAME_TYPE_MIRROR = 'mirror';
export const CANVAS_FRAME_TYPE_SOLID_COLOR = 'solid_color';
export const CANVAS_FRAME_TYPE_NATURAL = 'natural';
export const CANVAS_FRAME_TYPE_EXTEND = 'extend';

export const USD = 'USD';
export const EUR = 'EUR';

export const CUSTOM_SIZE = 'custom';
export const PATTERN_DESIGN_KEY = 'patterns';

// order sample steps
export const INITIAL_LOAD = 0;
export const LOAD_DEFAULT = 1;
export const DEFAULT_TILED_SCALE = 30.0;

// Share via Email
export const SHARE_VIEW_LINK = 'View link';
export const SHARE_EDIT_LINK = 'Edit link';
export const SHARE_TYPE_VIEW_LINK = 'View';
export const SHARE_TYPE_EDIT_LINK = 'Edit';

// Supported languages for vanilla
export const VANILLA_SUPPORTED_LANGUAGES = [
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'th',
  'en',
  'zh-Hans'
];
export const GA_EVENT_CATEGORY = {
  POSTERS: 'Poster job creation',
  PERSONIZE: 'Personize job creation',
  JOB_CREATION: 'job creation',
  FEEDBACK: 'Feedback',
  JOB_ORDER_DOWNLOAD: 'Job order download'
};

export const GA_EVENT_ACTIONS = {
  DESIGNER_LAUNCH: 'Designer is launched',
  STEP_1_START_ORDER: 'Step 1 - Start order',
  STEP_2_REVIEW_ORDER: 'Step 2 - Review order',
  STEP_2_DESIGN: 'Step 2 - Design',
  STEP_3_REVIEW_ORDER: 'Step 3 - Review order',
  BEFORE_LOGIN: 'Before vanilla login',
  AFTER_LOGIN: 'After vanilla login',
  BEFORE_WEBLINK_LOGIN: 'Before weblink login',
  AFTER_WEBLINK_LOGIN: 'After weblink login',
  SELECT_INSPIRATION_TEMPLATES: 'Select inspiration templates',
  USED_INSPIRATION_TEMPLATES: 'Used inspiration templates',
  ADD_BACKGROUND: 'Add background',
  ADD_PHOTO: 'Add photo',
  ADD_OBJECT: 'Add object',
  ADD_CUSTOM_CONTENT: 'Add custom content',
  ADD_TEXT: 'Add text',
  ADD_AR_LINK: 'Add AR link',
  CLICK_ON_ADD_TEXT: 'Click on add text',
  HIT_HELP_BUTTON: 'Hit help button',
  START_TOUR_GUIDE: 'Start tour guide',
  FINISH_TOUR_GUIDE: 'Finish tour guide',
  SHARE_JOB_PROJECT: 'Share job project',
  SAVE_JOB_PROJECT: 'Save job project',
  JOB_SUBMITTED: 'Job submitted',
  REQUEST_FOR_QUOTATION: 'Request for quotation',
  ADD_TO_CART: 'Add to cart',
  SAVE_TEMPLATE: 'Save template',
  ADD_TEMPLATE: 'Add template',
  CREATE_INSPIRATION: 'Create inspiration',
  HIT_LINK_TO_DOWNLOAD_HP_CLICK: 'Hit link to download HpClick',
  HIT_LINK_TO_DOWNLOAD_SMART_STREAM: 'Hit link to download SmartStream',
  GO_BACK_TO_EDIT_DESIGN: 'Go back to edit design',
  FEEDBACK_SUBMITTED: 'Feedback submitted',
  FEEDBACK_CANCELLED: 'Feedback cancelled',
  DESIGNER_TIME_USAGE: 'Designer time usage',
  SELECT_MODEL_TYPE: 'Select model type',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  DOWNLOAD_ORDER_THROUGH_RIP: 'Download order through',
  IMAGE_RECOLOR: 'Image recolor'
};

export const GA_EVENET_LABEL = {
  TOTAL_TIME: 'Total Time',
  DESIGN: 'Design',
  FEEDBACK_CANCELLED: 'Feedback Cancelled',
  REVIEW_ORDER: 'Review Order',
  FILE_PROCESSING: 'File Processing',
  DESIGN_SHARE_PAGE: 'Design Share',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied'
};

// Dreamstime account types
export const SUBSCRIPTION_TYPE = 'Subscription';
export const CREDITS_TYPE = 'Credit';

// Dreamstime licence type
export const RF_LICENCE = 'RF';
export const DEFAULT_LICENCE_SIZE = 'X';

export const MIN_UPLOAD_STATUS = 98;

// Upload error cases
export const UNSUPPORTED_FILE_TYPE_ERROR = 'UNSUPPORTED_FILE_TYPE';
export const ENCRYPTED_PDF_ERROR = 'ENCRYPTED_PDF_ERROR';
export const UNSUPPORTED_FILE_SIZE_ERROR = 'FILE_SIZE_ERROR';
export const PROCESSING_FAILED = 'PROCESSING_FAILED';
export const MULTIPAGE_PDF_NOT_SUPPORTED_TEXT = 'MULTIPAGE_PDF';
export const OPEN_PDF_ERROR = 'OPEN_PDF_ERROR';

export const SIDE_BAR_WIDTH = 392;
export const HEADER_HEIGHT = 48;

export const PHOTO_UPLOAD_KEY = 'PHOTO_UPLOAD_KEY';
export const OBJECT_UPLOAD_KEY = 'OBJECT_UPLOAD_KEY';
export const BACKGROUND_UPLOAD_KEY = 'BACKGROUND_UPLOAD_KEY';
export const DROPBOX_KEY = 'DROPBOX_KEY';
export const INSTAGRAM_KEY = 'INSTAGRAM_KEY';

// Pattern info
export const PATTERN_AUTHOR = 'Martina Stadler, patterndesigns.com';
export const PATTERN_COUNTRY = 'Austria';
export const PATTERN_DESCRIPTION =
  'The modern and orientalistic\nappearing design builds an exciting contrast to the dark background.';
export const PATTERN_PROFILE_URL =
  'https://www.patterndesigns.com/en/designer/2/Martina-Stadler';

export const ERROR = 'ERROR';
export const FAILED = 'FAILED';
export const UPLOAD_TEMPLATE = 'uploadTemplate';

export const PARTNER_STORE_ARC = 'ARC';
// Ruler size
export const RULER_SIZE = 35;
export const RULER_SMALL = 5;
export const RULER_MEDIUM = 10;
export const RULER_LARGE = 15;

export const THEME = {
  STICKERS: 'Stickers'
};

// Timer
export const SECONDS_TIMER = 1000; // 1sec
export const FEEDBACK_INTERVAL_FOR_PROCESSING_PAGE = 3000; // 3sec
export const ZOOM_MAGNIFIER_SIZE = 125;
export const MAGNIFIER_SCALE_FACTOR = 50;
export const MAGNIFIER_TILE_SCALE_FACTOR = 2;

// Page
export const DESIGN_KEY = 'Design';
export const FINAL_CHECK_KEY = 'Final Check';
export const ZOOM_SCALE_FACTOR = 0.5;

// standard tab id
export const TEMPLATES_KEY = 'templates';
export const BACKGROUNDS_KEY = 'backgrounds';
export const PHOTOS_KEY = 'photos';
export const OBJECTS_KEY = 'objects';
export const TEXT_KEY = 'text';
export const MATERIALS_KEY = 'materials';
export const UPLOAD_KEY = 'upload';
export const SETTINGS_KEY = 'settings';

export const SEARCH_COUNT = 30;

// Laptop 3D hosts
export const CL3VER_HOST = 'CL3VER';
export const SKETCH_FAB = 'SKETCHFAB';
export const THREE_JS = 'ThreeJS';

export const DEFAULT_PROJECT_WIDTH = 144;
export const DEFAULT_PROJECT_HEIGHT = 96;

export const GLOSSSY_FINISHING = 'Glossy';
export const MATTE_FINISHING = 'Matte';
export const TURKEY_KEY = 'Turkey';
export const BELGIUM_KEY = 'Belgium';
export const WESTCOAST_KEY = 'Westcoast';
export const FRANCE_KEY = 'France';
export const SINGLE_PRODUCT = 1;

export const THREE_D_TYPE = '3D';
export const TWO_D_TYPE = '2D';
export const EDIT_WORKSPACE_TYPE = 'editWorkspace';
export const VISUALIZE_TYPE = 'visualize';

export const CONSTRAINT_TYPE_CUSTOM = 'Custom';
export const CONSTRAINT_TYPE_PDF = 'PDF';

export const CANVAS_CONSTRAINT_TILE_TYPE = 'Constraint';
export const CANVAS_FREESTYLE_TILE_TYPE = 'Freesytle';

export const MAX_CANVAS_WALL_SIZE = 999 * 12 * 12;
export const WALL_MAXIMUM_TOTAL_HEIGHT = 98 * 12;
export const WALL_MINIMUM_TOTAL_WIDTH = 24;
export const WALL_MINIMUM_TOTAL_HEIGHT = 50;

export const SUBMITTED_KEY = 'submitted';
export const REJECTED_KEY = 'rejected';

export const WALLART_CANVAS_OFFSET = 100;
export const WALLPAPER_CANVAS_OFFSET_Y = 250;
export const SIGNAGE_CANVAS_OFFSET = 200;
export const SIGNAGE_MOBILE_CANVAS_OFFSET_X = 50;
export const SIGNAGE_MOBILE_CANVAS_OFFSET_Y = 150;

export const DISPLAY_IMAGES_COUNT = 8;
export const EMAIL_KEY = 'email';

export const HP_SMART_STREAM_KEY = 'HP SmartStream';
export const HP_CLICK = 'HP Click';

// platform
export const WEB = 'web';
export const IOS = 'iphone';
export const ANDROID = 'android';
export const MOBILE = 'mobile';

// device type
export const ANDROID_WEB_APP = 'ANDROIDWebApp';
export const IOS_WEB_APP = 'IOSWebApp';
export const DESKTOP = 'desktop';

export const NON_EDITABLE_ALERT_HEADER =
  'NOTICE: Official source health advice – Editing features disabled';
export const NON_EDITABLE_ALERT_BODY =
  'COVID-19 health advice posters are sourced from official governmental or NGO health advisory bodies such as the World Health Organization. To comply with copyright requirements and to ensure our customers can produce health advice posters, confidant the content and source is reliable, no changes have been made to their content, and editing capabilities are disabled. The provision of these poster designs is done to help communities disseminate public health advice, but does not imply endorsement of their content, either by HP or your print service provider.';
export const covidInspirationCategory = 'covid19_health_advice';
export const windowsOfHopeInspirationCategory = 'windows_of_hope';
export const allInspirationCategory = 'all';

export const PROJECT_SUBMISSION_STATE = {
  DONT_SUBMIT_STATE: 'noSubmit',
  CONTINUE_ON_CLOSE_STATE: 'continueOnClose',
  SUBMIT_STATE: 'submit'
};

export const ORDER_DETAILS_FORM = {
  PROJECT_NAME: 'projectName',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ADDRESS: 'address',
  CITY: 'city',
  COUNTRY: 'country',
  STATE: 'state',
  ZIP_CODE: 'zipCode',
  PHONE_NUMBER: 'phoneNumber',
  CUSTOMER_NAME: 'cutsomerName',
  CUSTOMER_EMAIL: 'customerEmail',
  COMPANY_NAME: 'companyName',
  POSTAL_ADDRESS: 'postalAddress',
  ORDER_NUMBER: 'orderNumber',
  INVOICE: 'invoice',
  SERIAL_NUMBER: 'serialNumber',
  EXTRA_INFO: 'extraInfo',
  INSTRUCTION: 'instruction',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  PERSONAL_INFORMATION_CONDITION: 'personalInformationCondition',
  SERVICE_PROVIDER_CONDITION: 'serviceProviderCondition'
};

export const SIZE_RANGE_PER_APPS = {
  SBMediumSize: {
    width: 72.0,
    height: 30.0
  },
  SBLargeSize: {
    width: 144.0,
    height: 30.0
  },
  HBMediumSize: {
    width: 32.28,
    height: 94.49
  },
  HBLargeSize: {
    width: 32.28,
    height: 173.23
  }
};

export const SWITCH_VIEW_MODE = {
  FIRST_OPTION: 'first',
  SECOND_OPTION: 'second'
};

export const WALL_DIRECTION = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

export const MULTI_WALLS_LIMIT = 3;

export const SQFT_TO_SQMT_CONSTANT = 0.092903;
